import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useApplicationList } from 'src/hooks/api';
import { useApplicationListAuthorization } from 'src/modules/TenantManagement/ApplicationList';
import { StandardRouteParams } from 'src/types';

export const DynamicApplicationListBreadcrumb = () => {
  const { t } = useTranslation(['common']);

  const { applicationListId } = useParams<StandardRouteParams>();

  const { isError: isErrorEvaluations, isPending: isPendingEvaluations } =
    useApplicationListAuthorization(applicationListId);

  const { data, error, isPending } = useApplicationList(applicationListId, {
    // Only fetch once the user is confirmed authorized
    enabled: !isPendingEvaluations && !isErrorEvaluations,
  });

  if (isPending || isPendingEvaluations) {
    return t('common:loadingFeedback.loading');
  }

  if (error || isErrorEvaluations) {
    return t('common:error.error');
  }

  return `${t('glossary.applicationList')}: ${data.name}`;
};
